import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProductsTable from './components/ProductsTable';
import BreadCrumb from '../../shared/components/BreadCrumb';

const MaterialTable = () => (
  <Container>
    <Row>
      <Col md={12}>
      <BreadCrumb title="Products"/>
      </Col>
    </Row>
    <Row>
      <ProductsTable />
    </Row>
  </Container>
);

export default MaterialTable;
